import React from 'react';
import IconClose from 'assets/icons/IconClose';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import { ModifyValue } from 'containers/ProductDetail/hooks/useProductDetaillHooks';
import { callWebviewHandler, WebviewOperatorType } from 'utils/webview';

interface Props {
  title: string;
  modifyValue: ModifyValue;
  style?: React.CSSProperties;
  setModifyValue: (modifyValue: ModifyValue) => void;
}

const ModalHeader = (props: Props) => {
  const { title, modifyValue, setModifyValue, style } = props;

  return (
    <Row
      justifyContent="space-between"
      style={{
        position: 'sticky',
        top: 0,
        padding: '24px 0',
        width: '100%',
        background: '#fff',
        zIndex: 5,
        ...style,
      }}
    >
      <Text color="#1b1c1e" size="20px" weight={600}>
        {title}
      </Text>
      <Row
        onClick={() => {
          if (modifyValue.modifyStatus === 'introduce') {
            callWebviewHandler(WebviewOperatorType.EditorResizeHandler, {
              isVisible: false,
            });
          }

          setModifyValue({ ...modifyValue, modifyStatus: '' });
        }}
      >
        <IconClose color="#70737C" style={{ width: '24px' }} />
      </Row>
    </Row>
  );
};

export default ModalHeader;
